/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Dynamic Free Shipping Threshold Logic
  class DynamicFreeShipping {
    constructor() {
      // Load configuration from theme settings
      this.loadConfiguration();
      
      this.init();
    }

    loadConfiguration() {
      // Get settings from theme or use defaults
      const shippingSettings = window.themeSettings?.shipping || {};
      const configJson = shippingSettings.configJson || null;
      const countrySettings = shippingSettings.countrySettings || {};
      const defaults = shippingSettings.defaults || {
        threshold: 80,
        shipping_cost: 15,
        delivery_time: '2-5'
      };

      // Initialize empty objects
      this.countryThresholds = {};
      this.countryShippingCosts = {};
      this.countryDeliveryTimes = {};

      // Load from simple country settings (user-friendly fields)
      // These fields always have default values, so we always use them
      if (countrySettings.DE) {
        const de = countrySettings.DE;
        this.countryThresholds['DE'] = de.threshold || defaults.threshold;
        this.countryShippingCosts['DE'] = de.shipping_cost || defaults.shipping_cost;
        this.countryDeliveryTimes['DE'] = de.delivery_time || defaults.delivery_time;
      }

      if (countrySettings.CENTRAL_EU) {
        const group = countrySettings.CENTRAL_EU;
        const countries = group.countries || ['AT', 'CH', 'CZ', 'SK', 'HU', 'PL', 'SI'];
        countries.forEach(code => {
          this.countryThresholds[code] = group.threshold || defaults.threshold;
          this.countryShippingCosts[code] = group.shipping_cost || defaults.shipping_cost;
          this.countryDeliveryTimes[code] = group.delivery_time || defaults.delivery_time;
        });
      }

      if (countrySettings.BENELUX_WEST) {
        const group = countrySettings.BENELUX_WEST;
        const countries = group.countries || ['BE', 'LU', 'NL', 'FR', 'MC', 'GB', 'IE', 'LI'];
        countries.forEach(code => {
          this.countryThresholds[code] = group.threshold || defaults.threshold;
          this.countryShippingCosts[code] = group.shipping_cost || defaults.shipping_cost;
          this.countryDeliveryTimes[code] = group.delivery_time || defaults.delivery_time;
        });
      }

      if (countrySettings.NORDIC) {
        const group = countrySettings.NORDIC;
        const countries = group.countries || ['DK', 'SE', 'NO', 'FI', 'EE', 'LV', 'LT', 'IS'];
        countries.forEach(code => {
          this.countryThresholds[code] = group.threshold || defaults.threshold;
          this.countryShippingCosts[code] = group.shipping_cost || defaults.shipping_cost;
          this.countryDeliveryTimes[code] = group.delivery_time || defaults.delivery_time;
        });
      }

      if (countrySettings.SOUTHERN_EU) {
        const group = countrySettings.SOUTHERN_EU;
        const countries = group.countries || ['IT', 'ES', 'PT', 'GR'];
        countries.forEach(code => {
          this.countryThresholds[code] = group.threshold || defaults.threshold;
          this.countryShippingCosts[code] = group.shipping_cost || defaults.shipping_cost;
          this.countryDeliveryTimes[code] = group.delivery_time || defaults.delivery_time;
        });
      }

      if (countrySettings.EASTERN_EU) {
        const group = countrySettings.EASTERN_EU;
        const countries = group.countries || ['RO', 'BG', 'HR', 'BA', 'RS', 'UA'];
        countries.forEach(code => {
          this.countryThresholds[code] = group.threshold || defaults.threshold;
          this.countryShippingCosts[code] = group.shipping_cost || defaults.shipping_cost;
          this.countryDeliveryTimes[code] = group.delivery_time || defaults.delivery_time;
        });
      }

      // Then, parse JSON configuration if available (for advanced users - can override simple settings)
      if (configJson) {
        try {
          // If configJson is a string, parse it; otherwise use as-is
          const parsedConfig = typeof configJson === 'string' ? JSON.parse(configJson) : configJson;
          
          // Only process if it's an object
          if (parsedConfig && typeof parsedConfig === 'object') {
            // Extract values from configuration (this will override simple settings)
            Object.keys(parsedConfig).forEach(countryCode => {
              const countryData = parsedConfig[countryCode];
              if (countryData && typeof countryData === 'object') {
                const code = countryCode.toUpperCase();
                
                this.countryThresholds[code] = countryData.threshold || defaults.threshold;
                this.countryShippingCosts[code] = countryData.shipping_cost || defaults.shipping_cost;
                this.countryDeliveryTimes[code] = countryData.delivery_time || defaults.delivery_time;
              }
            });
          }
        } catch (error) {
          console.error('Error parsing shipping JSON configuration:', error);
        }
      }

      // Set default values
      this.countryThresholds['default'] = defaults.threshold;
      this.countryShippingCosts['default'] = defaults.shipping_cost;
      this.countryDeliveryTimes['default'] = defaults.delivery_time;
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.updateShippingThreshold();
          this.#bindCountrySelectorListeners();
        });
      } else {
        this.updateShippingThreshold();
        this.#bindCountrySelectorListeners();
      }
    }

    // Returns currently selected country from country selector if present
    getSelectedCountryCode() {
      const input = document.querySelector('.select-popout--country [data-popout-input][name="country_code"]');
      if (input && input.value) {
        return input.value.toUpperCase();
      }
      return null;
    }

    async getUserCountry() {
      try {
        const selectedCode = this.getSelectedCountryCode();
        if (selectedCode) {
          return selectedCode;
        }

        if (window.Shopify && window.Shopify.locale) {
          const locale = window.Shopify.locale;
          const countryCode = locale.split('-')[1] || locale.split('_')[1];
          if (countryCode) {
            return countryCode.toUpperCase();
          }
        }

        const language = navigator.language || navigator.userLanguage;
        const countryCode = language.split('-')[1];
        if (countryCode) {
          return countryCode.toUpperCase();
        }
      } catch (error) {
        return 'default';
      }
    }

    getThresholdForCountry(countryCode) {
      return this.countryThresholds[countryCode] || this.countryThresholds['default'];
    }

    getShippingCostForCountry(countryCode) {
      return this.countryShippingCosts[countryCode] || this.countryShippingCosts['default'];
    }

    getDeliveryTimeForCountry(countryCode) {
      return this.countryDeliveryTimes[countryCode] || this.countryDeliveryTimes['default'];
    }

    getShippingInfoForCountry(countryCode) {
      return {
        country: countryCode,
        freeShippingThreshold: this.getThresholdForCountry(countryCode),
        shippingCost: this.getShippingCostForCountry(countryCode),
        deliveryTime: this.getDeliveryTimeForCountry(countryCode)
      };
    }

    async updateShippingThreshold() {
      const countryCode = await this.getUserCountry();
      const threshold = this.getThresholdForCountry(countryCode);
      
      this.updateThresholdElements(threshold);
      this.updateCartMessages(threshold);
      window.dynamicShippingThreshold = threshold;
    }

    updateByCountry(countryCode) {
      const code = (countryCode || 'default').toUpperCase();
      const threshold = this.getThresholdForCountry(code);
      this.updateThresholdElements(threshold);
      this.updateCartMessages(threshold);
      window.dynamicShippingThreshold = threshold;
    }

    updateThresholdElements(threshold) {
      const elements = document.querySelectorAll('[data-limit]');
      elements.forEach(element => {
        element.setAttribute('data-limit', threshold);
      });

      const thresholdDisplays = document.querySelectorAll('[data-free-shipping-threshold]');
      thresholdDisplays.forEach(element => {
        element.textContent = `€${threshold}`;
      });
    }

    updateCartMessages(threshold) {
      const cartMessages = document.querySelectorAll('.cart__message');
      const templateMessages = document.querySelectorAll('template .cart__message');
      const allMessages = [...cartMessages, ...templateMessages];
      
      allMessages.forEach(message => {
        const leftToSpendElement = message.querySelector('[data-left-to-spend]');
        if (leftToSpendElement) {
          let cartTotal = 0;
          
          if (window.cartTotal) {
            cartTotal = window.cartTotal;
          } else {
            const cartTotalElement = document.querySelector('[data-cart-total]');
            if (cartTotalElement) {
              cartTotal = parseInt(cartTotalElement.getAttribute('data-cart-total')) || 0;
            }
          }
          
          const cartTotalInEuros = cartTotal / 100;
          const leftToSpend = Math.max(0, threshold - cartTotalInEuros);
          
          if (leftToSpend > 0) {
            leftToSpendElement.textContent = `€${leftToSpend.toFixed(2)}`;
          } else {
            leftToSpendElement.textContent = '€0.00';
          }
        }
      });
      
      this.updateProgressBars(threshold);
      this.updateTemplateElements(threshold);
    }

    updateTemplateElements(threshold) {
      const templates = document.querySelectorAll('template[data-cart-drawer-template]');
      
      templates.forEach(template => {
        const limitElements = template.content.querySelectorAll('[data-limit]');
        limitElements.forEach(element => {
          element.setAttribute('data-limit', threshold);
        });
        
        const leftToSpendElements = template.content.querySelectorAll('[data-left-to-spend]');
        leftToSpendElements.forEach(element => {
          let cartTotal = 0;
          if (window.cartTotal) {
            cartTotal = window.cartTotal;
          } else {
            const cartTotalElement = document.querySelector('[data-cart-total]');
            if (cartTotalElement) {
              cartTotal = parseInt(cartTotalElement.getAttribute('data-cart-total')) || 0;
            }
          }
          
          const cartTotalInEuros = cartTotal / 100;
          const leftToSpend = Math.max(0, threshold - cartTotalInEuros);
          
          element.textContent = `€${leftToSpend.toFixed(2)}`;
        });
      });
    }

    updateProgressBars(threshold) {
      const progressBars = document.querySelectorAll('.cart__message__progress');
      
      progressBars.forEach(bar => {
        let cartTotal = 0;
        
        if (window.cartTotal) {
          cartTotal = window.cartTotal;
        } else {
          const cartTotalElement = document.querySelector('[data-cart-total]');
          if (cartTotalElement) {
            cartTotal = parseInt(cartTotalElement.getAttribute('data-cart-total')) || 0;
          }
        }
        
        const cartTotalInEuros = cartTotal / 100;
        const percent = Math.min(100, (cartTotalInEuros / threshold) * 100);
        
        bar.style.width = `${percent}%`;
      });
    }

    recalculateOnCartUpdate() {
      if (window.dynamicShippingThreshold) {
        this.updateCartMessages(window.dynamicShippingThreshold);
      }
    }

    // Private: bind listeners to the Shopify country selector
    #bindCountrySelectorListeners() {
      // Click on country option (before form submission)
      document.addEventListener('click', (e) => {
        const option = e.target.closest('.select-popout--country [data-popout-option]');
        if (option) {
          const code = option.getAttribute('data-value');
          if (code) {
            this.updateByCountry(code);
          }
        }
      });

      // Hidden input value change (some themes update it programmatically)
      document.addEventListener('change', (e) => {
        const input = e.target.closest('.select-popout--country [data-popout-input][name="country_code"]');
        if (input && input.value) {
          this.updateByCountry(input.value);
        }
      });
    }
  }

  const dynamicShipping = new DynamicFreeShipping();

  document.addEventListener('cart:updated', () => {
    dynamicShipping.recalculateOnCartUpdate();
  });

  document.addEventListener('cart-drawer:updated', () => {
    dynamicShipping.recalculateOnCartUpdate();
  });

  document.addEventListener('cart:refresh', () => {
    setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 100);
  });

  document.addEventListener('cart:build', () => {
    setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 100);
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-cart-quantity-input]') || e.target.matches('.cart__quantity-input')) {
      setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 200);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-cart-remove]') || e.target.matches('.cart__remove')) {
      setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 200);
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList && node.classList.contains('cart-drawer')) {
              setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 100);
            }
            
            if (node.querySelector && node.querySelector('.cart__message')) {
              setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 100);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.dynamicShipping = dynamicShipping;

  class CartCountUpdater {
    constructor() {
      this.init();
    }

    init() {
      document.addEventListener('cart:updated', () => {
        this.updateCartCount();
      });

      document.addEventListener('cart-drawer:updated', () => {
        this.updateCartCount();
      });

      document.addEventListener('cart:refresh', () => {
        setTimeout(() => this.updateCartCount(), 100);
      });

      document.addEventListener('cart:build', () => {
        setTimeout(() => this.updateCartCount(), 100);
      });

      document.addEventListener('change', (e) => {
        if (e.target.matches('[data-cart-quantity-input]') || e.target.matches('.cart__quantity-input')) {
          setTimeout(() => this.updateCartCount(), 200);
        }
      });

      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-cart-remove]') || e.target.matches('.cart__remove')) {
          setTimeout(() => this.updateCartCount(), 200);
        }
      });

      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-add-to-cart]') || e.target.closest('[data-add-to-cart]')) {
          setTimeout(() => this.updateCartCount(), 100);
          setTimeout(() => this.updateCartCount(), 500);
          setTimeout(() => this.updateCartCount(), 1000);
        }
      });

      document.addEventListener('submit', (e) => {
        if (e.target.matches('[data-product-form]') || e.target.matches('[data-quickbuy-form]')) {
          setTimeout(() => this.updateCartCount(), 100);
          setTimeout(() => this.updateCartCount(), 500);
          setTimeout(() => this.updateCartCount(), 1000);
        }
      });

      document.addEventListener('cart:updated', () => {
        this.updateCartCount();
      });

      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-cart-drawer-toggle]') || e.target.closest('[data-cart-drawer-toggle]')) {
          setTimeout(() => this.updateCartCount(), 100);
        }
      });

      const cartObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            const addedNodes = Array.from(mutation.addedNodes);
            const removedNodes = Array.from(mutation.removedNodes);
            
            const hasCartChanges = addedNodes.some(node => 
              node.nodeType === Node.ELEMENT_NODE && 
              (node.classList?.contains('cart__item') || 
               node.querySelector?.('.cart__item') ||
               node.classList?.contains('cart-drawer'))
            ) || removedNodes.some(node => 
              node.nodeType === Node.ELEMENT_NODE && 
              (node.classList?.contains('cart__item') || 
               node.querySelector?.('.cart__item'))
            );
            
            if (hasCartChanges) {
              setTimeout(() => this.updateCartCount(), 100);
            }
          }
        });
      });

      cartObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      this.updateCartCount();
    }

    updateCartCount() {
      let cartCount = 0;

      if (window.cart && window.cart.item_count) {
        cartCount = window.cart.item_count;
      }
      else {
        this.fetchCartFromAPI().then(count => {
          cartCount = count;
          this.updateCartBadges(cartCount);
        }).catch(() => {
          cartCount = this.countCartItems();
          this.updateCartBadges(cartCount);
        });
        return;
      }

      this.updateCartBadges(cartCount);
    }

    async fetchCartFromAPI() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        return cart.item_count || 0;
      } catch (error) {
        throw error;
      }
    }

    countCartItems() {
      let totalCount = 0;

      const cartItems = document.querySelectorAll('.cart__item');
      cartItems.forEach(item => {
        const quantityInput = item.querySelector('[data-cart-quantity-input], .cart__quantity-input');
        if (quantityInput) {
          const quantity = parseInt(quantityInput.value) || 0;
          totalCount += quantity;
        }
      });

      if (totalCount === 0) {
        const cartTotalElement = document.querySelector('[data-cart-total]');
        if (cartTotalElement) {
          const cartTotal = parseInt(cartTotalElement.getAttribute('data-cart-total')) || 0;
          if (cartTotal > 0) {
            totalCount = 1;
          }
        }
      }

      if (totalCount === 0) {
        const cartCountElements = document.querySelectorAll('[data-cart-item-count]');
        cartCountElements.forEach(element => {
          const count = parseInt(element.textContent) || 0;
          totalCount += count;
        });
      }

      return totalCount;
    }

    updateCartBadges(count) {
      const badges = document.querySelectorAll('.cart-count-badge');
      
      badges.forEach(badge => {
        if (badge.closest('.btn--quick') || badge.closest('[data-atc-trigger]')) {
          return;
        }
        
        const displayCount = count > 99 ? '99+' : count.toString();
        
        badge.textContent = displayCount;
        badge.setAttribute('aria-label', `${displayCount} items in cart`);
        badge.style.display = 'block';
      });

      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      cartCountElements.forEach(element => {
        if (element.closest('.btn--quick') || element.closest('[data-atc-trigger]')) {
          return;
        }
        
        const displayCount = count > 99 ? '99+' : count.toString();
        element.textContent = displayCount;
      });
    }
  }

  const cartCountUpdater = new CartCountUpdater();

  window.updateCartCount = function() {
    cartCountUpdater.updateCartCount();
  };

  // Test function to simulate cart count changes
  window.testCartCount = function(count) {
    const badges = document.querySelectorAll('.cart-count-badge');
    badges.forEach(badge => {
      if (badge.closest('.btn--quick') || badge.closest('[data-atc-trigger]')) {
        return;
      }
      
      const displayCount = count > 99 ? '99+' : count.toString();
      badge.textContent = displayCount;
      badge.setAttribute('aria-label', `${displayCount} items in cart`);
      
      badge.style.display = 'block';
    });
  };

  window.refreshCartCount = function() {
    cartCountUpdater.fetchCartFromAPI().then(count => {
      cartCountUpdater.updateCartBadges(count);
    }).catch(() => {
      cartCountUpdater.updateCartCount();
    });
  };

  // Octane AI Quiz German Translation
  class OctaneQuizTranslator {
    constructor() {
      this.translations = {
        en: {},
        de: {
          // Page 1/6 - Main skin concerns (Abschnitt 1)
          "What are your main skin concerns?": "Was sind Ihre wichtigsten Hautprobleme?",
          "(Choose up to 3)": "(Wählen Sie bis zu 3)",
          "Dryness or tightness": "Trockenheit oder Spannungsgefühl",
          "Rough or uneven skin texture": "Raue oder unebene Hautstruktur",
          "Dull or tired-looking skin": "Stumpfe oder müde aussehende Haut",
          "Sensitivity or redness": "Empfindlichkeit oder Rötung",
          "Signs of aging (wrinkles, loss of firmness)": "Zeichen der Hautalterung (Falten, Verlust der Festigkeit)",
          "Oily or acne-prone skin": "Fettige oder zu Akne neigende Haut",
          "Sun protection": "Sonnenschutz",
          
          // Page 2/6 - Skin feel after showering (Abschnitt 1)
          "How does your skin usually feel after showering?": "Wie fühlt sich Ihre Haut normalerweise nach dem Duschen an?",
          "Very dry or tight": "Sehr trocken oder straff",
          "Normal": "Normal",
          "Oily in certain areas": "An bestimmten Stellen ölig",
          "Itchy or irritated": "Juckreiz oder Reizungen",
          
          // Page 3/6 - Hydration level preference (Abschnitt 2)
          "What level of hydration and texture of body product do you prefer?": "Welche Feuchtigkeitsversorgung und Textur bevorzugen Sie bei Körperpflegeprodukten?",
          "Light and fast-absorbing": "Leicht und schnell einziehend",
          "Deep hydration that lasts": "Tiefenwirksame, lang anhaltende Feuchtigkeitsversorgung",
          "Rich, nourishing texture": "Reichhaltige, pflegende Textur",
          "Not sure": "Nicht sicher",
          
          // Page 4/6 - When to apply body care (Abschnitt 3)
          "When do you typically apply body care?": "Wann pflegen Sie normalerweise Ihren Körper?",
          "Morning": "Guten Morgen",
          "Night": "Nacht",
          "Both": "Beides",
          "Just after showering": "Gleich nach dem Duschen",
          "Whenever I remember": "Wann immer ich mich erinnere",
          
          // Page 5/6 - Exfoliation preference (Abschnitt 3)
          "Are you looking for exfoliation or skin renewal?": "Möchten Sie Ihre Haut peelen oder erneuern?",
          "Yes, I want to smooth and brighten my skin": "Ja, ich möchte meine Haut glätten und aufhellen",
          "No, just hydration and comfort": "Nein, nur Feuchtigkeit und Komfort",
          "I'm not sure": "Ich bin mir nicht sicher",
          
          // Page 6/6 - Signs of aging (Abschnitt 4)
          "Are you noticing signs of skin aging?": "Bemerken Sie Anzeichen von Hautalterung?",
          "Fine lines or crepey skin": "Feine Linien oder faltige Haut",
          "Loss of firmness or elasticity": "Verlust von Festigkeit oder Elastizität",
          "Age spots or discolouration": "Altersflecken oder Verfärbungen",
          "Not really, I want preventive care": "Nicht wirklich, ich möchte Vorsorgeuntersuchungen",
          "Not a concern": "Kein Problem",
          
          // Loading page - Calculating results
          "Calculating your results...": "Berechne Ihre Ergebnisse...",
          
          // Final page - Recommended products
          "Your recommended products!": "Ihre empfohlenen Produkte!",
          "Cleanser": "Reinigungsmittel",
          "Lotion or Cream": "Lotion oder Creme",
          "Body Serum": "Body-Serum",
          "Sun Care": "Sonnenschutz",
          
          // Common elements
          "CONTINUE": "WEITER",
          "ADD TO CART": "IN DEN WARENKORB",
          "Powered by Octane AI": "Unterstützt von Octane AI"
        }
      };
      
      this.isGermanLocale = this.#detectGermanLocale();
      this.translatedElements = new WeakSet();
      
      if (this.isGermanLocale) {
        this.init();
      }
    }

    #detectGermanLocale() {
      // Check HTML lang attribute
      const htmlLang = document.documentElement.getAttribute('lang');
      if (htmlLang && (htmlLang.toLowerCase().startsWith('de') || htmlLang === 'de')) {
        return true;
      }

      // Check Shopify locale
      if (window.Shopify && window.Shopify.locale) {
        const locale = window.Shopify.locale.toLowerCase();
        if (locale.startsWith('de')) {
          return true;
        }
      }

      // Check URL path
      const path = window.location.pathname;
      if (path.startsWith('/de') || path.startsWith('/de-')) {
        return true;
      }

      return false;
    }

    init() {
      // Initial translation check
      this.translateQuiz();

      // Watch for dynamically loaded quiz content
      const observer = new MutationObserver(() => {
        this.translateQuiz();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Also check periodically for late-loading content
      let checkCount = 0;
      const maxChecks = 20;
      const interval = setInterval(() => {
        if (checkCount >= maxChecks) {
          clearInterval(interval);
          return;
        }
        
        this.translateQuiz();
        checkCount++;
      }, 500);
    }

    translateQuiz() {
      const quizWrapper = document.getElementById('octane-quiz-wrapper');
      if (!quizWrapper) {
        return;
      }

      // Translate title
      const titleElement = quizWrapper.querySelector('[data-element="oct-quiz-text oct-quiz-title"]');
      if (titleElement && !this.translatedElements.has(titleElement)) {
        this.#translateElement(titleElement);
        this.translatedElements.add(titleElement);
      }

      // Translate subheading
      const subheadingElement = quizWrapper.querySelector('[data-element="oct-quiz-text oct-quiz-subheading"]');
      if (subheadingElement && !this.translatedElements.has(subheadingElement)) {
        this.#translateElement(subheadingElement);
        this.translatedElements.add(subheadingElement);
      }

      // Translate multiple choice options
      const optionItems = quizWrapper.querySelectorAll('.oct-quiz-multiple-choice-options__option');
      optionItems.forEach(item => {
        // Get all text divs (excluding empty/icon divs)
        const textDivs = Array.from(item.querySelectorAll('div')).filter(div => {
          const text = div.textContent.trim();
          // Only translate divs with meaningful text (at least 2 characters and contains letters)
          return text && text.length >= 2 && /[a-zA-Z]/.test(text);
        });
        
        textDivs.forEach(div => {
          if (!this.translatedElements.has(div)) {
            this.#translateElement(div);
            this.translatedElements.add(div);
          }
        });
      });

      // Translate continue button
      const continueButton = quizWrapper.querySelector('[data-element="oct-quiz-btn oct-quiz-submit-btn oct-quiz-media"] button');
      if (continueButton && !this.translatedElements.has(continueButton)) {
        this.#translateElement(continueButton);
        this.translatedElements.add(continueButton);
      }

      // Translate product categories on results page (Cleanser, Lotion or Cream, etc.)
      const productCategoryTitles = quizWrapper.querySelectorAll('[data-element="oct-quiz-text oct-quiz-title"][data-content-section="top_content"]');
      productCategoryTitles.forEach(categoryTitle => {
        if (!this.translatedElements.has(categoryTitle)) {
          this.#translateElement(categoryTitle);
          this.translatedElements.add(categoryTitle);
        }
      });

      // Translate "ADD TO CART" buttons on results page
      const allButtons = quizWrapper.querySelectorAll('button');
      allButtons.forEach(button => {
        const buttonText = button.textContent.trim();
        if (buttonText === 'ADD TO CART' && !this.translatedElements.has(button)) {
          button.textContent = 'IN DEN WARENKORB';
          this.translatedElements.add(button);
        }
      });

      // Translate watermark/powered by text
      const poweredByLink = quizWrapper.querySelector('[data-element="oct-quiz-rich-text"][data-content-section="watermark"] a');
      if (poweredByLink && !this.translatedElements.has(poweredByLink)) {
        const originalText = poweredByLink.textContent.trim();
        if (originalText.includes('Powered by Octane AI')) {
          poweredByLink.textContent = originalText.replace('Powered by Octane AI', 'Unterstützt von Octane AI');
          this.translatedElements.add(poweredByLink);
        }
      }

      // Translate "Powered by Octane AI" in bottom_content section
      const bottomContentLinks = quizWrapper.querySelectorAll('[data-element="oct-quiz-rich-text"][data-content-section="bottom_content"] a');
      bottomContentLinks.forEach(link => {
        const linkText = link.textContent.trim();
        if (linkText.includes('Powered by Octane AI') && !this.translatedElements.has(link)) {
          link.innerHTML = link.innerHTML.replace('Powered by Octane AI', 'Unterstützt von Octane AI');
          this.translatedElements.add(link);
        }
      });
    }

    #translateElement(element) {
      if (!element || !element.textContent) {
        return;
      }

      const originalText = element.textContent.trim();
      
      // Direct match
      if (this.translations.de[originalText]) {
        element.textContent = this.translations.de[originalText];
        return;
      }

      // Handle dynamic text like "What are your main skin concerns? (1/6)"
      // Try to match and translate the main part while preserving numbers/formatting
      for (const [key, value] of Object.entries(this.translations.de)) {
        if (originalText.includes(key)) {
          // Escape special regex characters in the key
          const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          
          // Try to match with key at the start (for titles with page numbers like "(1/6)")
          const matchStart = originalText.match(new RegExp(`^${escapedKey}(.*)$`));
          if (matchStart) {
            const additionalText = matchStart[1] || '';
            element.textContent = value + additionalText;
            return;
          }
          
          // Try to match with key in the middle or end
          const matchAnywhere = originalText.match(new RegExp(`(.*)${escapedKey}(.*)$`));
          if (matchAnywhere) {
            const prefix = matchAnywhere[1] || '';
            const suffix = matchAnywhere[2] || '';
            element.textContent = prefix + value + suffix;
            return;
          }
        }
      }
    }
  }

  // Initialize translator when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new OctaneQuizTranslator();
    });
  } else {
    new OctaneQuizTranslator();
  }

  // Fix: Prevent German language from persisting when switching to non-German countries
  class LocalizationFormHandler {
    constructor() {
      this.init();
    }

    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.bindHandlers();
        });
      } else {
        this.bindHandlers();
      }
    }

    bindHandlers() {
      // Use capture phase to intercept clicks early
      document.addEventListener('click', (e) => {
        this.handleCountryOptionClick(e);
      }, true); // Capture phase

      // Watch for changes to country_code input
      this.watchCountryInputChanges();

      // Also bind to form submit as fallback
      this.bindFormSubmitHandler();
    }

    handleCountryOptionClick(e) {
      const countryOption = e.target.closest('.select-popout--country [data-popout-option]');
      if (!countryOption) return;

      const countryCode = countryOption.getAttribute('data-value');
      if (!countryCode) return;

      // Save user's manual selection to localStorage
      localStorage.setItem('shopify_country_code', countryCode.toUpperCase());

      // Find the form that contains this country selector
      const form = countryOption.closest('form.localization-form, form[action*="/localization"]');
      if (!form) return;

      const currentPath = window.location.pathname;

      // Redirect to /de/ when selecting Germany or Austria
      if (['DE', 'AT'].includes(countryCode.toUpperCase())) {
        if (!currentPath.startsWith('/de')) {
          this.setReturnUrl(form, currentPath, true);
        }
      } else {
        // Remove /de prefix if switching from German/Austrian country
        if (currentPath.startsWith('/de') || currentPath.startsWith('/de-')) {
          this.setReturnUrl(form, currentPath, false);
        }
      }
    }

    watchCountryInputChanges() {
      // Watch for changes to country_code inputs
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            const input = mutation.target;
            if (input.name === 'country_code' && input.value) {
              // Save country selection to localStorage
              localStorage.setItem('shopify_country_code', input.value.toUpperCase());
              
              const form = input.closest('form.localization-form, form[action*="/localization"]');
              if (form) {
                const currentPath = window.location.pathname;
                // Redirect to /de/ when selecting Germany or Austria
                if (['DE', 'AT'].includes(input.value.toUpperCase())) {
                  if (!currentPath.startsWith('/de')) {
                    this.setReturnUrl(form, currentPath, true);
                  }
                } else {
                  // Remove /de prefix if switching from German/Austrian country
                  if (currentPath.startsWith('/de') || currentPath.startsWith('/de-')) {
                    this.setReturnUrl(form, currentPath, false);
                  }
                }
              }
            }
          }
        });
      });

      // Observe all country_code inputs
      const observeInputs = () => {
        const inputs = document.querySelectorAll('input[name="country_code"]');
        inputs.forEach(input => {
          observer.observe(input, {
            attributes: true,
            attributeFilter: ['value']
          });
        });
      };

      observeInputs();

      // Also watch for dynamically added inputs
      const bodyObserver = new MutationObserver(() => {
        observeInputs();
      });

      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    setReturnUrl(form, currentPath, addGermanPrefix = false) {
      const currentSearch = window.location.search;

      let newPath = currentPath;

      if (addGermanPrefix) {
        if (!newPath.startsWith('/de')) {
          if (newPath === '/') {
            newPath = '/de';
          } else if (newPath.startsWith('/')) {
            newPath = '/de' + newPath;
          } else {
            newPath = '/de/' + newPath;
          }
        }
      } else {
        newPath = newPath.replace(/^\/de(-[a-z]+)?/, '');

        if (!newPath.startsWith('/')) {
          newPath = '/' + newPath;
        }

        if (newPath === '/') {
          newPath = '/';
        }

        if (newPath === '') {
          newPath = '/';
        }
      }

      const returnUrl = newPath + currentSearch;
      
      // Check if return_to input already exists
      let returnToInput = form.querySelector('input[name="return_to"]');
      
      if (!returnToInput) {
        // Create new return_to input
        returnToInput = document.createElement('input');
        returnToInput.type = 'hidden';
        returnToInput.name = 'return_to';
        form.appendChild(returnToInput);
      }
      
      // Set the return URL without German language
      returnToInput.value = returnUrl;
    }

    bindFormSubmitHandler() {
      // Find all localization forms
      const forms = document.querySelectorAll('form.localization-form, form[action*="/localization"]');
      
      forms.forEach((form) => {
        form.addEventListener('submit', (e) => {
          this.handleFormSubmit(e);
        }, true); // Use capture phase
      });

      // Also listen for dynamically added forms
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.tagName === 'FORM' && (node.classList.contains('localization-form') || (node.action && node.action.includes('/localization')))) {
                node.addEventListener('submit', (e) => {
                  this.handleFormSubmit(e);
                }, true);
              }
              
              // Check for forms inside added nodes
              const forms = node.querySelectorAll && node.querySelectorAll('form.localization-form, form[action*="/localization"]');
              if (forms) {
                forms.forEach(form => {
                  form.addEventListener('submit', (e) => {
                    this.handleFormSubmit(e);
                  }, true);
                });
              }
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    handleFormSubmit(e) {
      const form = e.target;
      const countryInput = form.querySelector('input[name="country_code"]');
      
      if (!countryInput) {
        return;
      }

      const selectedCountry = countryInput.value.toUpperCase();
      
      // Save country selection to localStorage
      localStorage.setItem('shopify_country_code', selectedCountry);
      
      const currentPath = window.location.pathname;

      // Redirect to /de/ when selecting Germany or Austria
      if (['DE', 'AT'].includes(selectedCountry)) {
        if (!currentPath.startsWith('/de')) {
          this.setReturnUrl(form, currentPath, true);
        }
      } else {
        // Remove /de prefix if switching from German/Austrian country
        if (currentPath.startsWith('/de') || currentPath.startsWith('/de-')) {
          this.setReturnUrl(form, currentPath, false);
        }
      }
    }
  }

  // Initialize localization form handler
  new LocalizationFormHandler();

  // Auto-detect and set user's country
  class CountryAutoDetector {
    constructor() {
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.detectAndSetCountry();
        });
      } else {
        this.detectAndSetCountry();
      }
    }

    // Detect country using multiple methods
    detectCountry() {
      // Method 1: Try to get country from browser's Intl API
      try {
        const locale = Intl.DateTimeFormat().resolvedOptions();
        const timeZone = locale.timeZone;
        
        // Map common timezones to country codes
        const timezoneToCountry = {
          'Europe/Vienna': 'AT',
          'Europe/Brussels': 'BE',
          'Europe/Sofia': 'BG',
          'Europe/Zagreb': 'HR',
          'Europe/Prague': 'CZ',
          'Europe/Copenhagen': 'DK',
          'Europe/Tallinn': 'EE',
          'Europe/Helsinki': 'FI',
          'Europe/Paris': 'FR',
          'Europe/Berlin': 'DE',
          'Europe/Athens': 'GR',
          'Europe/Budapest': 'HU',
          'Europe/Dublin': 'IE',
          'Europe/Rome': 'IT',
          'Europe/Riga': 'LV',
          'Europe/Vilnius': 'LT',
          'Europe/Luxembourg': 'LU',
          'Europe/Amsterdam': 'NL',
          'Europe/Warsaw': 'PL',
          'Europe/Lisbon': 'PT',
          'Europe/Bucharest': 'RO',
          'Europe/Bratislava': 'SK',
          'Europe/Ljubljana': 'SI',
          'Europe/Stockholm': 'SE'
        };

        if (timezoneToCountry[timeZone]) {
          return timezoneToCountry[timeZone];
        }
      } catch (e) {
        console.warn('Could not detect country from timezone:', e);
      }

      // Method 2: Try to get from locale string
      try {
        const locale = navigator.language || navigator.userLanguage;
        const countryCode = locale.split('-')[1]?.toUpperCase();
        if (countryCode && countryCode.length === 2) {
          return countryCode;
        }
      } catch (e) {
        console.warn('Could not detect country from locale:', e);
      }

      // Method 3: Try to get from languages array
      try {
        if (navigator.languages && navigator.languages.length > 0) {
          for (const lang of navigator.languages) {
            const parts = lang.split('-');
            if (parts.length > 1) {
              const countryCode = parts[1].toUpperCase();
              if (countryCode && countryCode.length === 2) {
                return countryCode;
              }
            }
          }
        }
      } catch (e) {
        console.warn('Could not detect country from languages:', e);
      }

      return null;
    }

    setCountry(countryCode) {
      if (!countryCode) return false;

      const countrySelectors = document.querySelectorAll('.select-popout--country');
      let success = false;
      
      countrySelectors.forEach((selector) => {
        const input = selector.querySelector('input[name="country_code"][data-popout-input]');
        const options = selector.querySelectorAll('[data-popout-option]');
        
        if (!input) return;

        const availableCountry = Array.from(options).find(
          option => option.getAttribute('data-value')?.toUpperCase() === countryCode.toUpperCase()
        );

        if (!availableCountry) {
          return;
        }

        const currentValue = input.value?.toUpperCase();
        if (currentValue === countryCode.toUpperCase()) {
          this.updateUI(selector, countryCode);
          success = true;
          return;
        }

        input.value = countryCode.toUpperCase();

        this.updateUI(selector, countryCode);

        input.dispatchEvent(new Event('change', { bubbles: true }));
        success = true;
      });

      return success;
    }

    updateUI(selector, countryCode) {
      const options = selector.querySelectorAll('[data-popout-option]');
      const toggle = selector.querySelector('.select-popout__toggle');
      
      if (!toggle) return;

      const items = selector.querySelectorAll('.select-popout__item');
      items.forEach(item => {
        item.classList.remove('select-popout__item--current');
        const option = item.querySelector('[data-popout-option]');
        if (option) {
          option.removeAttribute('aria-current');
        }
      });

      options.forEach(option => {
        const value = option.getAttribute('data-value')?.toUpperCase();
        if (value === countryCode.toUpperCase()) {
          const item = option.closest('.select-popout__item');
          if (item) {
            item.classList.add('select-popout__item--current');
            option.setAttribute('aria-current', 'true');
          }

          const flag = option.querySelector('.select-popout__flag');
          const text = option.querySelector('span');
          
          if (flag && toggle) {
            const existingFlag = toggle.querySelector('.select-popout__flag');
            if (existingFlag) {
              existingFlag.replaceWith(flag.cloneNode(true));
            } else {
              toggle.insertBefore(flag.cloneNode(true), toggle.firstChild);
            }
          }

          if (text && toggle) {
            const existingText = toggle.querySelector('span:not(.select-popout__flag)');
            if (existingText) {
              existingText.textContent = text.textContent.trim();
            } else {
              const newSpan = document.createElement('span');
              newSpan.style.whiteSpace = 'nowrap';
              newSpan.textContent = text.textContent.trim();
              toggle.insertBefore(newSpan, toggle.querySelector('.icon-select'));
            }
          }
        }
      });
    }

    async detectAndSetCountry() {
      await new Promise(resolve => setTimeout(resolve, 100));

      const countryInputs = document.querySelectorAll('.select-popout--country input[name="country_code"]');
      let hasCountrySet = false;

      countryInputs.forEach(input => {
        if (input.value && input.value.length === 2) {
          hasCountrySet = true;
        }
      });

      const savedCountry = localStorage.getItem('shopify_country_code');
      if (savedCountry) {
        // For DE/AT: redirect BEFORE calling setCountry to avoid Shopify AJAX
        // updating announcement bar in German while the page is still in English
        if (['DE', 'AT'].includes(savedCountry.toUpperCase())) {
          const currentPath = window.location.pathname;
          if (!currentPath.startsWith('/de')) {
            const currentSearch = window.location.search;
            const newPath = currentPath === '/' ? '/de' : '/de' + currentPath;
            window.location.href = newPath + currentSearch;
            return;
          }
        }
        // Non DE/AT: safe to update selector (no redirect = no mixed-language flash)
        this.setCountry(savedCountry);
        return;
      }

      const detectedCountry = this.detectCountry();

      if (detectedCountry && !hasCountrySet) {
        // For DE/AT: redirect immediately, skip setCountry entirely to prevent
        // the change event from triggering a German AJAX update on an English page
        if (['DE', 'AT'].includes(detectedCountry.toUpperCase())) {
          const currentPath = window.location.pathname;
          if (!currentPath.startsWith('/de')) {
            localStorage.setItem('shopify_country_code', detectedCountry);
            const currentSearch = window.location.search;
            const newPath = currentPath === '/' ? '/de' : '/de' + currentPath;
            window.location.href = newPath + currentSearch;
            return;
          }
        }
        const success = this.setCountry(detectedCountry);
        if (success) {
          localStorage.setItem('shopify_country_code', detectedCountry);
        }
      } else if (detectedCountry && hasCountrySet) {
        const currentCountry = countryInputs[0]?.value?.toUpperCase();

        if (['DE', 'AT'].includes(detectedCountry.toUpperCase()) && ['DE', 'AT'].includes(currentCountry)) {
          const currentPath = window.location.pathname;
          if (!currentPath.startsWith('/de')) {
            const currentSearch = window.location.search;
            const newPath = currentPath === '/' ? '/de' : '/de' + currentPath;
            window.location.href = newPath + currentSearch;
            return;
          }
        }
      }
    }
  }

  // Initialize country auto-detector
  new CountryAutoDetector();

  // Bundle Products Sorting Handler
  // This class moves bundle products to the end of the product grid for any sorting option
  class BundleSortingHandler {
    constructor() {
      this.sortedGrids = new WeakSet();
      this.isSorting = false;
      this.init();
    }

    init() {
      // Run on page load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.moveBundlesToEnd();
        });
      } else {
        this.moveBundlesToEnd();
      }

      // Watch for AJAX updates (filtering, sorting, pagination)
      this.observeCollectionUpdates();
    }

    moveBundlesToEnd() {
      // Find all product grids on the page
      const productGrids = document.querySelectorAll('[data-collection-products] .grid');

      productGrids.forEach(grid => {
        this.sortProductsInGrid(grid);
      });
    }

    sortProductsInGrid(grid) {
      // Prevent sorting if already in progress
      if (this.isSorting) return;

      // Get all product items
      const products = Array.from(grid.querySelectorAll('[data-product-block]'));

      if (products.length === 0) return;

      // Separate bundles from regular products
      const bundles = [];
      const regularProducts = [];

      products.forEach(product => {
        if (product.hasAttribute('data-product-bundle')) {
          bundles.push(product);
        } else {
          regularProducts.push(product);
        }
      });

      // Check if bundles are already at the end
      if (bundles.length > 0) {
        const lastProducts = products.slice(-bundles.length);
        const bundlesAlreadyAtEnd = lastProducts.every(product =>
          product.hasAttribute('data-product-bundle')
        );

        // If bundles are already correctly positioned, skip reordering
        if (bundlesAlreadyAtEnd) {
          this.sortedGrids.add(grid);
          return;
        }

        // Set flag to prevent infinite loop
        this.isSorting = true;

        // Remove all products from the grid
        products.forEach(product => {
          product.remove();
        });

        // Add regular products first
        regularProducts.forEach(product => {
          grid.appendChild(product);
        });

        // Add bundles at the end
        bundles.forEach(bundle => {
          grid.appendChild(bundle);
        });

        // Mark this grid as sorted
        this.sortedGrids.add(grid);

        // Reset flag after a short delay
        setTimeout(() => {
          this.isSorting = false;
        }, 200);
      }
    }

    observeCollectionUpdates() {
      // Listen for filter/sort changes
      const collectionContainer = document.querySelector('[data-section-type="collection-template"]');
      if (collectionContainer) {
        // Watch for sort option changes
        const sortInputs = collectionContainer.querySelectorAll('[data-input-sort]');
        sortInputs.forEach(input => {
          input.addEventListener('change', () => {
            // Clear sorted grids on sort change
            this.sortedGrids = new WeakSet();
            setTimeout(() => {
              this.moveBundlesToEnd();
            }, 800);
          });
        });

        // Watch for filter changes
        const filterInputs = collectionContainer.querySelectorAll('[data-collection-filter-tag-button]');
        filterInputs.forEach(input => {
          input.addEventListener('click', () => {
            // Clear sorted grids on filter change
            this.sortedGrids = new WeakSet();
            setTimeout(() => {
              this.moveBundlesToEnd();
            }, 800);
          });
        });
      }

      // Watch for AJAX pagination (infinite scroll)
      const paginationObserver = new MutationObserver((mutations) => {
        let hasNewProducts = false;

        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.hasAttribute('data-product-block') ||
                    node.querySelector('[data-product-block]')) {
                  hasNewProducts = true;
                }
              }
            });
          }
        });

        if (hasNewProducts) {
          clearTimeout(this.sortTimeout);
          this.sortTimeout = setTimeout(() => {
            const grids = document.querySelectorAll('[data-collection-products] .grid');
            grids.forEach(grid => {
              this.sortedGrids.delete(grid);
              this.sortProductsInGrid(grid);
            });
          }, 300);
        }
      });

      // Observe product grid containers for new products
      const observePaginationGrids = () => {
        const grids = document.querySelectorAll('[data-collection-products]');
        grids.forEach(grid => {
          paginationObserver.observe(grid, {
            childList: true,
            subtree: true
          });
        });
      };

      observePaginationGrids();
    }
  }

  // Initialize bundle sorting handler
  new BundleSortingHandler();

  // Move Sun Protection Duo to position 5 (second row) in all collection pages
  (function () {
    if (!window.location.pathname.includes('/collections/')) return;

    function moveSunProtectionDuo() {
      const grid = document.querySelector('[data-collection-products] .grid') ||
                   document.querySelector('.product-grid');
      if (!grid) return false;

      const items = Array.from(grid.querySelectorAll('[data-product-block]'));
      if (items.length < 2) return false;

      const targetItem = items.find(function (item) {
        return item.querySelector('a[href*="sun-protection-duo"]');
      });
      if (!targetItem) return false;

      // Insert so SPF lands at 6th position from the end (5 items remain after it)
      const others = items.filter(function (item) { return item !== targetItem; });
      const anchor = others.length >= 6 ? others[others.length - 5] : null;
      if (anchor) {
        grid.insertBefore(targetItem, anchor);
      } else {
        grid.appendChild(targetItem);
      }
      return true;
    }

    // Delay to run after BundleSortingHandler has finished
    setTimeout(function () {
      if (!moveSunProtectionDuo()) {
        const observer = new MutationObserver(function (_, obs) {
          if (moveSunProtectionDuo()) obs.disconnect();
        });
        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () { observer.disconnect(); }, 10000);
      }
    }, 400);
  })();

  // Shared: format a price (in Shopify cents) using the current market's currency
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format(cents / 100);
  }

  // Shared: detect market URL prefix (e.g. /de, /cs)
  function getLocalePrefix() {
    var m = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    return m ? '/' + m[1] : '';
  }

  // Shopper Bag: prepend local-currency strikethrough and fix redirect link in all bundle widgets
  (function () {
    const BAG_PRODUCT_ID = 'gid://shopify/Product/16277889876313';
    const BAG_HANDLE = 'shopper-bag';

    function modifyShopperBag() {
      const container = document.getElementById('bundleComponentsContainer');
      if (!container) return false;
      if (container.dataset.shopperBagModified) return true;

      const bagCard = container.querySelector('[data-product-id="' + BAG_PRODUCT_ID + '"]');
      if (!bagCard) return false;

      container.dataset.shopperBagModified = '1';

      // Fix link — prevent navigating away from the current product page
      const link = bagCard.querySelector('.BC_bundle-product-link');
      if (link) {
        link.setAttribute('href', window.location.pathname);
        link.addEventListener('click', function (e) { e.preventDefault(); });
      }

      // Prepend strikethrough price in local market currency
      const priceDiv = bagCard.querySelector('.BC_bundle-product-price');
      if (priceDiv) {
        const oldPrice = document.createElement('span');
        oldPrice.className = 'BC_sale-price BC_old-price';
        oldPrice.textContent = '€13,00'; // shown immediately, replaced by fetch result
        priceDiv.insertBefore(oldPrice, priceDiv.firstChild);

        fetch(getLocalePrefix() + '/products/' + BAG_HANDLE + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var price = product.compare_at_price_max || product.compare_at_price_min;
            if (price && price > 0) {
              oldPrice.textContent = formatMoney(price);
            }
          })
          .catch(function () {});
      }

      return true;
    }

    if (!modifyShopperBag()) {
      const observer = new MutationObserver(function (_, obs) {
        if (modifyShopperBag()) obs.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 10000);
    }
  })();

  // Sun Protection Duo — inject second SPF card with 50% off pricing
  (function () {
    if (!window.location.pathname.includes('sun-protection-duo')) return;

    const PLUS_ICON_SVG = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.80762 3.25726V11.4239" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.72437 7.34058H11.891" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

    function modifyBundleWidget() {
      const container = document.getElementById('bundleComponentsContainer');
      if (!container) return false;

      const products = container.querySelectorAll('.BC_bundle-product');
      if (products.length < 2) return false;

      if (container.dataset.spfModified) return true;
      container.dataset.spfModified = '1';

      const spfCard = products[0];

      // Get handle from existing link before DOM manipulation
      const spfLink = spfCard.querySelector('.BC_bundle-product-link');
      const spfHref = spfLink ? spfLink.getAttribute('href') : '';
      const handleMatch = spfHref.match(/\/products\/([^/?#]+)/);
      const spfHandle = handleMatch ? handleMatch[1] : null;

      // Set EUR fallback prices immediately so nothing is blank
      const firstPriceEl = spfCard.querySelector('.BC_sale-price');
      if (firstPriceEl) firstPriceEl.textContent = '€59,00';

      const firstPlusIcon = container.querySelector('.BC_plus-icon');

      // Clone SPF card for the discounted version
      const discountedCard = spfCard.cloneNode(true);
      const discountedPriceDiv = discountedCard.querySelector('.BC_bundle-product-price');
      if (discountedPriceDiv) {
        discountedPriceDiv.innerHTML =
          '<span class="BC_sale-price BC_old-price">€59,00</span>' +
          '<span class="BC_sale-price BC_very-sale">€47,20</span>';
      }

      // Create second plus icon
      const secondPlusIcon = document.createElement('div');
      secondPlusIcon.className = 'BC_plus-icon';
      secondPlusIcon.innerHTML = PLUS_ICON_SVG;

      // Insert: [SPF full price] [+] [SPF discounted] [+] [Shopper Bag]
      firstPlusIcon.insertAdjacentElement('afterend', secondPlusIcon);
      firstPlusIcon.insertAdjacentElement('afterend', discountedCard);

      // Fetch SPF price in local market currency and update both cards
      if (spfHandle) {
        fetch(getLocalePrefix() + '/products/' + spfHandle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var fullPrice = product.price;
            var discountedPrice = Math.round(fullPrice * 0.8); // 20% off second unit
            if (firstPriceEl) firstPriceEl.textContent = formatMoney(fullPrice);
            if (discountedPriceDiv) {
              discountedPriceDiv.innerHTML =
                '<span class="BC_sale-price BC_old-price">' + formatMoney(fullPrice) + '</span>' +
                '<span class="BC_sale-price BC_very-sale">' + formatMoney(discountedPrice) + '</span>';
            }
          })
          .catch(function () {});
      }

      return true;
    }

    if (!modifyBundleWidget()) {
      const observer = new MutationObserver(function (_, obs) {
        if (modifyBundleWidget()) obs.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 10000);
    }
  })();

  // Redirect "Body Concentrate - Sun Protection" collection to SPF product page
  (function () {
    if (window.location.pathname === '/collections/body-concentrate-sun-protection') {
      window.location.replace('/products/sun-protection-duo');
    }
  })();

  // German collection filter value translations
  (function () {
    if (!window.location.pathname.startsWith('/de')) return;
    if (!window.location.pathname.includes('/collections/')) return;

    const TRANSLATIONS = {
      'Sunscreen': 'Sonnenschutz',
      'Sun Protection': 'Sonnenschutz',
    };

    function translateFilterValues() {
      const walker = document.createTreeWalker(
        document.body,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function (node) {
            return TRANSLATIONS[node.textContent.trim()]
              ? NodeFilter.FILTER_ACCEPT
              : NodeFilter.FILTER_SKIP;
          }
        }
      );
      var nodes = [];
      var n;
      while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach(function (node) {
        node.textContent = TRANSLATIONS[node.textContent.trim()];
      });
    }

    translateFilterValues();

    var debounce;
    var obs = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(translateFilterValues, 150);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  })();

})();